// カスタム投稿「製品」ブロックエディター用のアコーディオン
$(function () {
    $('.c-product-block-accordion').each(function () {
        const $accordion = $(this);
        const $button = $accordion.find('.c-product-block-accordion__btn');
        const $detail = $accordion.find('.c-product-block-accordion__detail');

        // 初期状態は閉じる
        $detail.hide();

        $button.attr('aria-expanded', 'false');

        // =====================================================
        // ボタンクリック
        // =====================================================
        $button.on('click', function () {
            $accordion.toggleClass('is-open');
            $detail.stop(true, true).slideToggle(300);

            // =====================================================
            // 開閉状態
            // =====================================================
            if ($accordion.hasClass('is-open')) {
                $button.text('閉じる');
                $button.attr('aria-expanded', 'true');
                $button.addClass('is-open');
            } else {
                $button.text('詳細情報をみる');
                $button.attr('aria-expanded', 'false');
                $button.removeClass('is-open');
            }
        });
    });
});
